import React, { useContext, useState } from 'react';
import './gestiones.scss';
import { ModalFormProps } from 'components/Types/GeneralTypes';
import PDFViewer from '../PDFViewer';
import { PostGuardarGestion, GetVistaPreviaFormularioJustificacion, formatDateForInput } from 'services/justificaciones';
import Swal from 'sweetalert2';
import EventContext from 'Context/EventContext'; 


const OPCIONES_SELECT_MOTIVO = ["Descuido personal", "Distracción", "Olvido", "Omisión involuntaria"];

const JustificacionForm: React.FC<ModalFormProps> = ({ isOpen, tipo , jornadaLaboral,onAccept ,onCancel}) => {
  const { updateEvents } = useContext(EventContext);

  const [tipoJustificacionId, setTipoJustificacionId] = useState<number>(0);
  const jornada = jornadaLaboral.jornada;
  const receso = jornadaLaboral.receso;
  const [horaDesde, setHoraDesde] = useState('');
  const [horaHasta, setHoraHasta] = useState('');
  const [pdfUrl, setPdfUrl] = useState('');
  const [previewMode, setPreviewMode] = useState(false);
  const [motivo, setMotivo] = useState(OPCIONES_SELECT_MOTIVO[0]); 
  const fecha = formatDateForInput(jornadaLaboral.fecha);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [timeInputVisibility, setTimeInputVisibility] = useState({ showHoraDesde: true, showHoraHasta: true });
  React.useEffect(() => {
    if (isOpen) {
      resetForm();
      if (tipo=='L') {
        setContextFromJornada();
      } else if (receso) {
        setContextFromReceso();
      }
    }
  }, [isOpen, jornada]);

  const resetForm = () => {
    setTipoJustificacionId(0);
    setHoraDesde('');
    setHoraHasta('');
    setPdfUrl('');
    setPreviewMode(false);
    setMotivo(OPCIONES_SELECT_MOTIVO[0]);
    setIsLoading(false);
    setError('');
  };
  const setContextFromJornada = () => {
    const metodo = jornada?.gestionJ?.metodo;
    setTimeInputVisibility({
        showHoraDesde: metodo !== 'SALIDA',
        showHoraHasta: metodo !== 'INGRESO'
      });

    setHoraDesde( jornada?.inicio ||  jornadaLaboral?.horario?.horaInicio || '08:00');
    setHoraHasta(jornada?.fin || jornadaLaboral?.horario?.horaFin || '16:30');
    setDescripcion(jornada?.gestionJ?.descripcion || '');
    setTipoJustificacionId(jornada?.gestionJ?.id || 0);
  };

  const setContextFromReceso = () => {
    const metodo = receso?.gestionJ?.metodo;
    const horaingreso= receso?.inicio ||   jornadaLaboral?.horario?.recesoInicio ||'12:00';
    setHoraDesde(horaingreso);
    setDescripcion(receso?.gestionJ?.descripcion || '');
    setHoraHasta(calculateEndTime(horaingreso) || '12:30');
    setTipoJustificacionId(receso?.gestionJ?.id || 0);
    setTimeInputVisibility({
      showHoraDesde: metodo !== 'SALIDA',
      showHoraHasta: metodo !== 'INGRESO'
    });
  };
  
  const calculateEndTime = (startTime) => {
    if (startTime) {
      const [hour, minutes] = startTime.split(':').map(Number);
      const endTime = new Date(Date.UTC(1970, 0, 1, hour, minutes + 30));
      return endTime.toISOString().substring(11, 16);
    }
    return null;
  };
 

const processJustification = async (actionCallback, isPreview) => {
  setIsLoading(true);
  setError('');
  const justificacion = {
    idpersona: 0,
    entrada: horaDesde,
    salida: horaHasta,
    fecha: fecha,
    subtipo: tipoJustificacionId,
    tipo: "J",
    observacion: motivo,
  };

  try {
    const resultado = await actionCallback(justificacion);
    if (resultado.status === 200 && resultado.dataResponse !== undefined) {
      setPdfUrl(resultado.dataResponse);
      if (isPreview) {
        setPreviewMode(true);
      } else {
        onAccept(); 
      }
      setIsLoading(false);
      setError('');
      return { success: true }; 
    } else {
      const message = resultado.errorMessage || 'No se pudo procesar la solicitud. Por favor, intenta nuevamente.';
      setError(message);
      setIsLoading(false);
      return { error: true, message: message }; 
    }
  } catch (error) {
      setError(error instanceof Error ? error.message : 'Error desconocido al conectar con el servidor.');
      setIsLoading(false);
      return { error: true, message: error }; 
  }
};


const handlePreview = () => {
  processJustification(GetVistaPreviaFormularioJustificacion, true);
};

const handleAccept = () => {
  if (previewMode) {
    processJustification(PostGuardarGestion, false)
    .then((result) => {
      if(result.success){
      Swal.fire({
        title: 'Éxito!',
        text: 'Se ha generado con éxito su solicitud de justificación. Recuerde hacer la gestión respectiva con su directivo de unidad.',
        icon: 'success',
        confirmButtonText: 'Cerrar'
      }).then((result) => {
        if (result.isConfirmed) {
          updateEvents(); 
          onCancel(); 
        }
      });
    }else{
      Swal.fire({
        title: 'Error!',
        text: 'No se ha podido generar su solicitud de justificación. Por favor, intente nuevamente.',
        icon: 'error',
        confirmButtonText: 'Cerrar'
      });
    }
    }).catch((error) => {
      Swal.fire({
        title: 'Error!',
        text: 'No se ha podido generar su solicitud de justificación. Por favor, intente nuevamente.',
        icon: 'error',
        confirmButtonText: 'Cerrar'
      });
    });
  } else {
    handlePreview();
  }
};

const handleCancel = () => {
  setPdfUrl('');
  onCancel();
};

  if (!isOpen) {
    return null; 
  }


  return (
    <div className="modal-gestion-overlay">
      <div className="modal-container-just justify-content-center modal-form">
        <div className="card">
          <div className="card-body">
            <h6 className="card-title">Solicitud de justificación de marcación</h6>
            <div className="form-group">
              <label htmlFor="fecha">Jornada de trabajo que solicita justificar:</label>
              <input id="fecha" className="form-control" type="date" value={fecha} readOnly />
            </div>
            <div className="form-group">
              <label htmlFor="tipo">Correspondiente a la marcación de:</label>
              <select className="form-control" id="tipo" value={descripcion} disabled={true}>
                <option value={descripcion}>{descripcion}</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="hora">Horas que solicita se registre como marcación:</label>
              <div className="form-row">
              {timeInputVisibility.showHoraDesde && (
                <div className="col">
                <input className="form-control" type="time" value={horaDesde} onChange={(e) => setHoraDesde(e.target.value)} readOnly={true} />
                </div>
              )}
              {timeInputVisibility.showHoraHasta && (
                <div className="col">
                  <input className="form-control" type="time" value={horaHasta} onChange={(e) => setHoraHasta(e.target.value)} readOnly={true} />
                </div>
              )}
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="motivo">Motivo por el cual no registró la marcación:</label>
              <select className="form-control" id="motivo"  disabled={previewMode}  onChange={(e) => setMotivo(e.target.value)}>
                {OPCIONES_SELECT_MOTIVO.map((opcion) => (
                  <option key={opcion} value={opcion}>{opcion}</option>
                ))}
              </select>
            </div>
            {error && <p className="text-danger">{error}</p>}
            {pdfUrl && (
              <div className="pdf-viewer-container">
                <PDFViewer url={pdfUrl} heightValue={"100%"} />
              </div>
            )}
            <div className="form-group d-flex justify-content-between">
              <button className="btn btn-danger" onClick={handleCancel}>Cancelar</button>
              <button className="btn btn-secondary" onClick={handleAccept} disabled={isLoading || !!error}>
                {isLoading ? <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Cargando...
                </> : (previewMode ? "Aceptar" : "Vista Previa")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JustificacionForm;